import { Box, LinearProgress, Stack, Typography } from '@mui/material'
import React from 'react'

import { RELIABILITY_REPORT_COLORS } from 'components/reliability-management/reliability-management-utils'
import { filterReliabilityScore } from 'components/services/service-utils'
import theme from 'theme'
import { PolicyCategory } from 'types/api/policies/policy'
import {
  CategoryScores,
  CategoryScoreSummary
} from 'types/api/policies/reliability-report'
import { TeamReliabilityCategorySummary } from 'types/api/reports/team/reliability-report'
import { naturalSortBy } from 'utils/list'

const ReliabilityScoreDetails: React.FC<{
  scores: CategoryScores | TeamReliabilityCategorySummary
}> = ({ scores }) => {
  const sortedReportCategories = naturalSortBy(
    Object.entries(scores ?? {}),
    (c: [PolicyCategory, CategoryScoreSummary]) => {
      return c[1].rank
    }
  )

  return (
    <>
      <Stack alignItems="end">
        {sortedReportCategories.map(([type, results], index) => {
          const percent = (results.score / results.maxScore) * 100

          return (
            <React.Fragment key={`${type}-${index}`}>
              <Stack
                data-test-reliability-score-details={type}
                direction="row"
                gap={1}
              >
                <Typography noWrap css={{ textOverflow: 'clip' }}>
                  {results.category}
                </Typography>
                <Typography css={{ color: theme.colors.steel[0] }}>
                  +{filterReliabilityScore(results.score)}
                </Typography>
              </Stack>
              <Box
                sx={{
                  width: '100%',
                  '& .MuiLinearProgress-barColorPrimary': {
                    backgroundColor: RELIABILITY_REPORT_COLORS[type]
                  }
                }}
              >
                <LinearProgress
                  sx={{ backgroundColor: '#d9d9d9', height: 6 }}
                  value={percent}
                  variant="determinate"
                />
              </Box>
            </React.Fragment>
          )
        })}
      </Stack>
    </>
  )
}

export default ReliabilityScoreDetails
